import { render, staticRenderFns } from "./ImageWithLink.vue?vue&type=template&id=847583f4&"
import script from "./ImageWithLink.vue?vue&type=script&lang=js&"
export * from "./ImageWithLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports